import React from "react";

export const SiteMetadataContext = React.createContext({});
